import { logger } from '@/lib/newRelic/logger';
import { processFetchRequest } from '@/utils/fetch/processFetchRequest';

interface ProductSubscriptionByRegion {
  region: string;
  assetCategoryCode: string;
}

export type CustomerType =
  (typeof subscriptionCategories)[keyof typeof subscriptionCategories];

export interface SubscriptionType {
  code: string;
  customerType: string;
  isFlexible: boolean;
  isSpecialOffer: boolean;
  minDurationMonths: 1 | 6 | 12;
  oneOffFee: number;
  rate: number;
}

export type ProductSubscriptionByRegionResponse = SubscriptionType[];

export const subscriptionCategories = {
  normal: 'normal',
  student: 'student',
  heavyUse: 'heavyuser',
} as const;

export const fetchProductSubscriptionsByRegion = async ({
  region,
  assetCategoryCode,
}: ProductSubscriptionByRegion) => {
  return processFetchRequest<ProductSubscriptionByRegionResponse>({
    url: `${process.env.SUBSCRIPTION_TYPES_API}?region=${region}&product=${assetCategoryCode}`,
    name: fetchProductSubscriptionsByRegion.name,
  }).catch(e => {
    if (e.status !== 404) {
      logger.error('fetchProductSubscriptionsByRegion method failed', {
        fetchError: e,
      });
      throw e; // re-throw the error unchanged unless 404
    } else {
      logger.warn('fetchProductSubscriptionsByRegion method failed', {
        fetchError: e,
      });
    }
  });
};
